import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "src/shared/shared.module";
import { NearbyMainResolver } from "./main/nearby-main-resolver";
import { NearbyMapPage } from "./main/nearby-main";
import { NearbyEventParticipantSearchPage } from "./nearby-event-participant-search/nearby-event-participant-search";
import { NearbyEventParticipantsPage } from "./nearby-event-participants/nearby-event-participants";
import { NearbyModifyStartPage } from "./nearby-modify-start/nearby-modify-start";
import { IonicModule } from "@ionic/angular";
const routes: Routes = [
    { path: '', loadComponent: () =>
      import('./main/nearby-main').then(m => m.NearbyMapPage)
    },
    { path: 'participant-search', loadComponent: () =>
      import('./nearby-event-participant-search/nearby-event-participant-search').then(m => m.NearbyEventParticipantSearchPage)
    },
    { path: 'event-participants', loadComponent: () =>
      import('./nearby-event-participants/nearby-event-participants').then(m => m.NearbyEventParticipantsPage)
    },
    { path: 'modify-start', loadComponent: () =>
      import('./nearby-modify-start/nearby-modify-start').then(m => m.NearbyModifyStartPage)
    },
  ];
@NgModule({
    declarations: [
      NearbyMapPage,
      NearbyEventParticipantSearchPage,
      NearbyEventParticipantsPage,
      NearbyModifyStartPage
    ],
    imports: [
        HttpClientModule,
        SharedModule,
        CommonModule,
        RouterModule,
        TranslateModule,
        RouterModule.forChild(routes)
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
    ]
  })
  export class NearbyModule { }
  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }